import React from "react"
import SideNav from "../SideNav/SideNav"
import classes from "./MainImage.module.scss"
import Image from "gatsby-image"

const MainImage = ({ image, title, type }) => {
  return (
    <div className={classes.MainImage}>
      <nav className={classes.SideNav}>
        <SideNav type={type} />
      </nav>
      <div className={classes.Img}>
        <Image fluid={image} />
      </div>
      <div>
        <p>{title}</p>
      </div>
    </div>
  )
}

export default MainImage
